import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManageComponentsComponent } from './pages/manage-components.component';
import { SharedModule } from '../../shared/shared.module';
import { MaterialModule } from '../../shared/material.module';
import { FormsModule } from '@angular/forms';
import {ManageComponentsService} from'./manage-components.service';
import {HttpModule} from '@angular/http';
import { ComponentDetailsComponent } from './component-details/component-details.component';
import { UploadCompImageComponent } from './upload-comp-image/upload-comp-image.component';
import { ComponentImageUploadComponent } from './component-image-upload/component-image-upload.component';
import { SetupModelsComponent } from '../setup-models/pages/setup-models.component';
import { SetupFamilyComponent } from '../setup-family/pages/setup-family.component';
import { MatStepperModule } from '@angular/material/stepper';
import { ComponentExtradetailPopupComponent } from './pages/component-extradetail-popup/component-extradetail-popup.component';


@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        MaterialModule,
        FormsModule,
        HttpModule,
        MatStepperModule,
    ],
    declarations: [
        ManageComponentsComponent,
        ComponentDetailsComponent,
        UploadCompImageComponent,
        ComponentImageUploadComponent,
        ComponentExtradetailPopupComponent,
    ],
    providers: [ManageComponentsService]
})
export class ManageComponentsModule { }
